import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function VoucherTypeIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="63"
      height="65"
      viewBox="0 0 63 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M62.4929 37.0349C60.7145 52.5291 49.7058 65 32.616 65C17.3219 65 1.31641 55.1928 1.31641 37.0349C1.31641 3.40116 18.7272 0 35.8171 0C52.9069 0 62.4929 18.8769 62.4929 37.0349Z"
        fill="#E3F1FF"
      />
      <g clipPath="url(#clip0_9308_11518)">
        <path
          d="M15.4697 18.75H43.2275C44.0526 18.75 44.7901 18.9195 45.2842 19.2656C45.6993 19.5565 46.0095 20.0148 46.002 20.8223L45.9961 20.9883C45.9813 21.2363 45.9473 21.5873 45.9473 21.9082V37.083C45.9473 38.0097 45.8151 38.6538 45.4844 39.0713C45.1846 39.4496 44.5855 39.8027 43.2275 39.8027H15.4697C13.9677 39.8027 12.75 38.5851 12.75 37.083V21.4697C12.75 20.0616 13.8201 18.903 15.1914 18.7637L15.4697 18.75Z"
          fill="white"
          stroke="#4E7FFF"
          strokeWidth="1.5"
        />
        <circle cx="30.4082" cy="28.7617" r="6.93945" fill="#E1E8F6" />
        <path
          d="M37.6619 32.4675V29.8554C37.6619 28.2328 36.4175 26.9119 34.8887 26.9119C33.3593 26.9119 32.1156 28.2329 32.1156 29.8554V33.0118C32.1156 34.0597 31.3445 34.9118 30.3967 34.9118C29.4482 34.9118 28.6771 34.0597 28.6771 33.0118V30.4636C30.3079 30.1918 31.5401 28.9925 31.5401 27.5581V23.3145C31.5401 22.437 30.7139 21.7236 29.6978 21.7236H29.1402C28.98 21.723 28.8266 21.7864 28.7132 21.8991C28.5998 22.0125 28.5365 22.1659 28.5365 22.3255C28.5365 22.4858 28.5998 22.6391 28.7132 22.7519C28.8266 22.8647 28.9799 22.928 29.1402 22.9274H29.6984C30.064 22.9274 30.337 23.132 30.337 23.3145V27.5581C30.337 28.5287 29.2777 29.3182 27.9757 29.3182C26.6731 29.3182 25.6139 28.5281 25.6139 27.5581V23.3145C25.6139 23.132 25.8869 22.9274 26.2525 22.9274H26.6523C26.8125 22.928 26.9659 22.8647 27.0793 22.7519C27.1927 22.6391 27.256 22.4858 27.256 22.3255C27.256 22.1659 27.1927 22.0125 27.0793 21.8991C26.9659 21.7864 26.8126 21.7236 26.6523 21.7236H26.2525C25.2369 21.7236 24.4102 22.437 24.4102 23.3145V27.5581C24.4102 29.0507 25.7451 30.2848 27.4735 30.4889V33.0118C27.4735 34.7231 28.7849 36.1156 30.3962 36.1156C32.0079 36.1156 33.3188 34.7231 33.3188 33.0118V29.8554C33.3188 28.8961 34.0227 28.1155 34.8882 28.1155C35.7536 28.1155 36.4581 28.8961 36.4581 29.8554V32.4675C35.5471 32.7633 34.987 33.6782 35.1365 34.6241C35.2867 35.57 36.1021 36.267 37.06 36.267C38.0179 36.267 38.834 35.57 38.9834 34.6241C39.1336 33.6782 38.5729 32.7633 37.6619 32.4675ZM37.1569 35.5789C36.9903 35.5789 36.856 35.444 36.856 35.278C36.856 35.112 36.9903 34.977 37.1569 34.977C37.5504 34.9764 37.8684 34.6577 37.8684 34.2643C37.8684 33.8709 37.5504 33.5515 37.1569 33.5509C36.9903 33.5509 36.856 33.4166 36.856 33.25C36.856 33.084 36.9903 32.949 37.1569 32.949C37.883 32.949 38.4716 33.5382 38.4716 34.2643C38.4716 34.9904 37.883 35.5789 37.1569 35.5789Z"
          fill="#4E7FFF"
        />
        <mask id="path-5-inside-1_9308_11518" fill="white">
          <path d="M18.4209 23.9251L18.3281 21.2656L18.4209 23.9251Z" />
        </mask>
        <path
          d="M17.4659 23.9585C17.4843 24.4859 17.9268 24.8986 18.4542 24.8802C18.9817 24.8618 19.3943 24.4193 19.3759 23.8918L17.4659 23.9585ZM19.2831 21.2323C19.2647 20.7049 18.8223 20.2922 18.2948 20.3106C17.7674 20.329 17.3547 20.7715 17.3731 21.2989L19.2831 21.2323ZM19.3759 23.8918L19.2831 21.2323L17.3731 21.2989L17.4659 23.9585L19.3759 23.8918Z"
          fill="#D680E0"
          mask="url(#path-5-inside-1_9308_11518)"
        />
        <mask id="path-7-inside-2_9308_11518" fill="white">
          <path d="M18.6055 28.6318L18.6611 30.2275L18.6055 28.6318Z" />
        </mask>
        <path
          d="M19.5605 28.5985C19.5421 28.0711 19.0996 27.6584 18.5722 27.6768C18.0447 27.6952 17.6321 28.1377 17.6505 28.6652L19.5605 28.5985ZM17.7061 30.2609C17.7245 30.7883 18.167 31.201 18.6944 31.1826C19.2219 31.1642 19.6346 30.7217 19.6162 30.1942L17.7061 30.2609ZM17.6505 28.6652L17.7061 30.2609L19.6162 30.1942L19.5605 28.5985L17.6505 28.6652Z"
          fill="#D680E0"
          mask="url(#path-7-inside-2_9308_11518)"
        />
        <mask id="path-9-inside-3_9308_11518" fill="white">
          <path d="M18.8477 34.9341L18.9404 37.5936L18.8477 34.9341Z" />
        </mask>
        <path
          d="M19.8027 34.9008C19.7843 34.3733 19.3418 33.9607 18.8143 33.9791C18.2869 33.9975 17.8742 34.44 17.8926 34.9674L19.8027 34.9008ZM17.9854 37.6269C18.0038 38.1543 18.4463 38.567 18.9737 38.5486C19.5012 38.5302 19.9138 38.0877 19.8954 37.5603L17.9854 37.6269ZM17.8926 34.9674L17.9854 37.6269L19.8954 37.5603L19.8027 34.9008L17.8926 34.9674Z"
          fill="#D680E0"
          mask="url(#path-9-inside-3_9308_11518)"
        />
        <path
          d="M20.4346 26.1973H48.1924C49.0174 26.1973 49.755 26.3668 50.249 26.7129C50.6641 27.0038 50.9744 27.4621 50.9668 28.2695L50.9609 28.4355C50.9462 28.6835 50.9121 29.0346 50.9121 29.3555V44.5303C50.9121 45.4569 50.78 46.1011 50.4492 46.5186C50.1494 46.8969 49.5503 47.25 48.1924 47.25H20.4346C18.9325 47.25 17.7148 46.0323 17.7148 44.5303V28.917C17.7148 27.5089 18.7849 26.3503 20.1562 26.2109L20.4346 26.1973Z"
          fill="white"
          stroke="#4E7FFF"
          strokeWidth="1.5"
        />
        <circle cx="35.373" cy="36.209" r="6.93945" fill="#E1E8F6" />
        <path
          d="M41.014 32.6359L31.4811 42.1688C31.1237 42.5222 30.6411 42.7199 30.1385 42.7186C29.6359 42.7173 29.1543 42.5173 28.7987 42.1621C28.4423 41.8053 28.2422 41.3217 28.2422 40.8175C28.2422 40.3133 28.4423 39.8297 28.7987 39.473L38.3249 29.9468"
          stroke="#4E7FFF"
          strokeWidth="1.34456"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.6523 29.2744L41.686 33.3081"
          stroke="#4E7FFF"
          strokeWidth="1.34456"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M34.9603 38.686H29.582"
          stroke="#4E7FFF"
          strokeWidth="1.34456"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <mask id="path-16-inside-4_9308_11518" fill="white">
          <path d="M23.3857 31.3724L23.293 28.7129L23.3857 31.3724Z" />
        </mask>
        <path
          d="M22.4307 31.4057C22.4491 31.9332 22.8916 32.3458 23.4191 32.3274C23.9465 32.309 24.3592 31.8665 24.3408 31.3391L22.4307 31.4057ZM24.248 28.6796C24.2296 28.1521 23.7871 27.7395 23.2597 27.7579C22.7322 27.7763 22.3196 28.2188 22.338 28.7462L24.248 28.6796ZM24.3408 31.3391L24.248 28.6796L22.338 28.7462L22.4307 31.4057L24.3408 31.3391Z"
          fill="#D680E0"
          mask="url(#path-16-inside-4_9308_11518)"
        />
        <mask id="path-18-inside-5_9308_11518" fill="white">
          <path d="M23.5703 36.0791L23.626 37.6748L23.5703 36.0791Z" />
        </mask>
        <path
          d="M24.5253 36.0458C24.5069 35.5183 24.0644 35.1057 23.537 35.1241C23.0096 35.1425 22.5969 35.585 22.6153 36.1124L24.5253 36.0458ZM22.671 37.7081C22.6894 38.2356 23.1318 38.6482 23.6593 38.6298C24.1867 38.6114 24.5994 38.1689 24.581 37.6415L22.671 37.7081ZM22.6153 36.1124L22.671 37.7081L24.581 37.6415L24.5253 36.0458L22.6153 36.1124Z"
          fill="#D680E0"
          mask="url(#path-18-inside-5_9308_11518)"
        />
        <mask id="path-20-inside-6_9308_11518" fill="white">
          <path d="M23.8125 42.3813L23.9053 45.0409L23.8125 42.3813Z" />
        </mask>
        <path
          d="M24.7675 42.348C24.7491 41.8206 24.3066 41.4079 23.7792 41.4263C23.2517 41.4447 22.8391 41.8872 22.8575 42.4147L24.7675 42.348ZM22.9503 45.0742C22.9687 45.6016 23.4111 46.0143 23.9386 45.9959C24.466 45.9775 24.8787 45.535 24.8603 45.0075L22.9503 45.0742ZM22.8575 42.4147L22.9503 45.0742L24.8603 45.0075L24.7675 42.348L22.8575 42.4147Z"
          fill="#D680E0"
          mask="url(#path-20-inside-6_9308_11518)"
        />
        <mask
          id="path-22-outside-7_9308_11518"
          maskUnits="userSpaceOnUse"
          x="33"
          y="33.1636"
          width="20"
          height="20"
          fill="black"
        >
          <rect fill="white" x="33" y="33.1636" width="20" height="20" />
          <path d="M50.8026 44.1674C50.3432 47.9343 47.4995 50.9661 43.085 50.9661C39.1344 50.9661 35 48.5819 35 44.1674C35 35.9905 39.4974 35.1636 43.9119 35.1636C48.3264 35.1636 50.8026 39.7529 50.8026 44.1674Z" />
        </mask>
        <path
          d="M50.8026 44.1674C50.3432 47.9343 47.4995 50.9661 43.085 50.9661C39.1344 50.9661 35 48.5819 35 44.1674C35 35.9905 39.4974 35.1636 43.9119 35.1636C48.3264 35.1636 50.8026 39.7529 50.8026 44.1674Z"
          fill="#FEB940"
        />
        <path
          d="M50.8026 44.1674L52.4281 44.3656L52.4402 44.2669V44.1674H50.8026ZM35 44.1674H36.6376H35ZM49.177 43.9691C48.8089 46.9873 46.6003 49.3285 43.085 49.3285V52.6038C48.3988 52.6038 51.8775 48.8812 52.4281 44.3656L49.177 43.9691ZM43.085 49.3285C41.4135 49.3285 39.7503 48.819 38.5449 47.9131C37.3772 47.0356 36.6376 45.7982 36.6376 44.1674H33.3624C33.3624 46.9511 34.69 49.1131 36.5772 50.5313C38.4266 51.9212 40.8059 52.6038 43.085 52.6038V49.3285ZM36.6376 44.1674C36.6376 40.3644 37.6731 38.7231 38.7688 37.9198C39.9808 37.0312 41.7216 36.8012 43.9119 36.8012V33.526C41.6878 33.526 38.9725 33.7093 36.8323 35.2784C34.5756 36.9329 33.3624 39.7934 33.3624 44.1674H36.6376ZM43.9119 36.8012C45.4725 36.8012 46.7321 37.5865 47.6642 38.9392C48.6184 40.324 49.165 42.2383 49.165 44.1674H52.4402C52.4402 41.6819 51.7486 39.0944 50.3611 37.0808C48.9516 35.0353 46.7659 33.526 43.9119 33.526V36.8012Z"
          fill="white"
          mask="url(#path-22-outside-7_9308_11518)"
        />
        <g clipPath="url(#clip1_9308_11518)">
          <path
            d="M43.5259 42.3686L42.9234 40.7723C42.7808 40.3946 42.335 40.2127 41.9284 40.3663C41.5217 40.5198 41.3073 40.9509 41.4498 41.3285M43.0955 41.2284C42.953 40.8507 43.1673 40.4197 43.574 40.2661C43.9807 40.1126 44.4265 40.2945 44.569 40.6722L45.1716 42.2685M40.2346 42.5688L40.124 42.6106C39.7228 42.762 39.3939 43.055 39.21 43.4256C38.9896 43.8688 38.9996 44.3741 39.2372 44.7878L40.0617 46.2243C40.7839 47.4821 42.3972 48.0054 43.856 47.4547L45.2475 46.9295C46.8752 46.3151 47.7321 44.592 47.1616 43.0805L46.2147 40.5721C46.0722 40.1944 45.6264 40.0125 45.2197 40.166C44.813 40.3195 44.5986 40.7506 44.7412 41.1283M40.5789 43.481L39.1155 39.6043C38.973 39.2266 39.1873 38.7955 39.594 38.642C40.0007 38.4885 40.4465 38.6704 40.589 39.048L42.0524 42.9248"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_9308_11518">
          <rect
            width="43.5713"
            height="43.5713"
            fill="white"
            transform="translate(9.85938 9.39795)"
          />
        </clipPath>
        <clipPath id="clip1_9308_11518">
          <rect
            width="11.9607"
            height="11.9607"
            fill="white"
            transform="translate(35.125 39.2241) rotate(-20.6799)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
